import * as Yup from 'yup';

export const LocationSchema = {
  Save: Yup.object().shape({
    callerId: Yup.string().optional(),
    city: Yup.string().required(),
    country: Yup.string().required(),
    description: Yup.string().optional(),
    location: Yup.string().optional(),
    locationName: Yup.string().required(),
    locationNumber: Yup.string().optional(),
    outgoingPhoneNumber: Yup.string().optional(),
    state: Yup.string().required(),
    streetDirection: Yup.string().optional(),
    streetName: Yup.string().required(),
    streetNumber: Yup.string().optional(),
    streetType: Yup.string().optional(),
    timeZone: Yup.string().required(),
    voiceEnabled: Yup.string().optional(),
    zip: Yup.string().required(),
  }),
};
